import { c as _c } from "react/compiler-runtime";
import { Stack, Tooltip, Typography, type TooltipProps } from '@mui/material';
import classnames from 'classnames';
import React from 'react';
interface TooltipContentProps {
  isAuthorized?: boolean;
  isFeatureSupported?: boolean;
  title: string | null;
  overrideTitle?: boolean;
}
const TooltipContent = props => {
  const $ = _c(14);
  const shouldShowTitle = props.title && (!props.overrideTitle || props.isAuthorized && props.isFeatureSupported);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      marginX: "4px",
      gap: "4px"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props.isAuthorized || $[2] !== props.title || $[3] !== shouldShowTitle) {
    t1 = shouldShowTitle && <Typography className={classnames("text-xs", {
      "font-semibold": !props.isAuthorized
    })} sx={{
      color: "var(--mui-palette-primary-dark)"
    }}>{props.title}</Typography>;
    $[1] = props.isAuthorized;
    $[2] = props.title;
    $[3] = shouldShowTitle;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props.isAuthorized) {
    t2 = !props.isAuthorized && <Typography className="text-xs" sx={{
      width: "176px",
      color: "var(--mui-palette-primary-dark)"
    }}>An admin has blocked this action for your current user role.</Typography>;
    $[5] = props.isAuthorized;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== props.isAuthorized || $[8] !== props.isFeatureSupported) {
    t3 = props.isAuthorized && !props.isFeatureSupported && <Typography className="text-xs" sx={{
      width: "176px",
      color: "var(--mui-palette-primary-dark)"
    }}>{"In order to use this feature, update the relevant account's permissions version."}</Typography>;
    $[7] = props.isAuthorized;
    $[8] = props.isFeatureSupported;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== t1 || $[11] !== t2 || $[12] !== t3) {
    t4 = <Stack direction="column" sx={t0}>{t1}{t2}{t3}</Stack>;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
};
interface AuthorizationTooltipProps extends Omit<TooltipProps, 'title'> {
  isAuthorized?: boolean;
  isFeatureSupported?: boolean;
  title?: string;
  overrideTitle?: boolean;
}
export const AuthorizationTooltip = props => {
  const $ = _c(17);
  let children;
  let t0;
  let t1;
  let t2;
  let tooltipProps;
  if ($[0] !== props) {
    ({
      children,
      isAuthorized: t0,
      isFeatureSupported: t1,
      overrideTitle: t2,
      ...tooltipProps
    } = props);
    $[0] = props;
    $[1] = children;
    $[2] = t0;
    $[3] = t1;
    $[4] = t2;
    $[5] = tooltipProps;
  } else {
    children = $[1];
    t0 = $[2];
    t1 = $[3];
    t2 = $[4];
    tooltipProps = $[5];
  }
  const isAuthorized = t0 === undefined ? true : t0;
  const isFeatureSupported = t1 === undefined ? true : t1;
  const overrideTitle = t2 === undefined ? false : t2;
  let t3;
  if ($[6] !== isAuthorized || $[7] !== isFeatureSupported || $[8] !== overrideTitle || $[9] !== props.title) {
    t3 = props.title || !isAuthorized || !isFeatureSupported ? <TooltipContent isAuthorized={isAuthorized} isFeatureSupported={isFeatureSupported} title={props.title || null} overrideTitle={overrideTitle} /> : undefined;
    $[6] = isAuthorized;
    $[7] = isFeatureSupported;
    $[8] = overrideTitle;
    $[9] = props.title;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const tooltipTitle = t3;
  let t4;
  if ($[11] !== children) {
    t4 = <span>{children}</span>;
    $[11] = children;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== t4 || $[14] !== tooltipProps || $[15] !== tooltipTitle) {
    t5 = <Tooltip {...tooltipProps} title={tooltipTitle}>{t4}</Tooltip>;
    $[13] = t4;
    $[14] = tooltipProps;
    $[15] = tooltipTitle;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
};